<template>
  <div class="container-double double mt-5 mb-5" v-if="cardText[0]">
    <div class="row justify-content-center mt-1">
      <div class="col-12 col-md-6 col-lg-5">
        <div class="double-image-item justify-content-end">  
          <div class="d-inline-block">
            <img :src="`/wp-content/interactivos/especial-pesca${cardText[0].imageBg}`" :alt="`${cardText[0].imageCredits}`"/>
          </div>
          <span class="creditos-picture d-inline-block d-md-none text-left">
            <div class="d-md-block d-none text-center">
              <span class="line"></span>
            </div>
            <div v-if="cardText[0] && cardText[0].imageCredits" class="texto-double" v-html="cardText[0].imageCredits">
              
            </div>
          </span>
          <span class="line mb-3  d-block d-md-none"></span>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-7" v-if="cardText[1]">
        <div class="double-image-item justify-content-start">
          <div class="d-inline-block">
            <img :src="cardText[1].imageBg"/>
          </div>
          <ul v-if="cardText[1] && cardText[1].imageCredits" class="creditos-picture d-inline-block d-md-none text-left">
            <li>
              {{ cardText[1].imageCredits }}
            </li>
          </ul>
          <span class=" mt-3 line d-block d-md-none"></span>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 pt-3 d-md-block d-none align-self-center">
        <span class="creditos-picture mb-3">
          <div v-if="cardText[0].imageCredits" class="mb-3 texto-double" v-html="cardText[0].imageCredits">
            
          </div>
          <div v-if="cardText[1] && cardText[1].imageCredits">
            <span v-if="cardText[1].imageCredits" class="item-position">{{ $t('item_image.right')}}</span> {{ cardText[1].imageCredits }}
          </div>
        </span>
      </div>      
    </div>
  </div>
</template>

<style lang="scss">

  /* double image */

  

  .container-double {
    width: 100%;
    max-width: 1320px;
  }

  .texto-double {
    font-size: 31px;
    font-weight: 900;
    text-align: left;
    color: #F28705;

    .role-text {
      font-size: 31px;
      font-weight: 900;
      text-align: left;
      color: #fff;
    }
  }



  .double {  
    width: 100%;

    ul.creditos-picture {
      padding-left: 25px;
    }

    h3 {
      padding: 15px 0;
      font-size: 27px;
      font-weight: 300;
      line-height: 1.3em;
      color: #999;

      @media screen and (max-width: 767px){
        font-size: 21px;
        text-align: center;
      }
    }

    .item-position {
      color: #ffca00;
    }

    .line {
      background-color: #171717;
      display: inline-block;
      height: 2px;
      width: 150px;
      margin: 0px auto;
    }

    .double-image-item {
      margin: 0 auto;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      text-align: center;

      @media screen and (max-width: 860px) {
        display: block;
        text-align: center;
      }

      img {
        display: block;
        height: auto;
        width: calc(100% - 20px);
        margin: 0 10px;

        @media screen and (max-width: 1220px) {
          display: block;
          height: auto;
          width: calc(100% - 20px);
          margin: 0 10px;
        }
      }

      .large {
        overflow: hidden;

        img {
          width: auto !important;
          max-width: auto !important;
          height: 80vh;

          @media screen and (max-width: 860px) {
            height: auto;
            width: 100% !important;
            object-fit: cover;
            margin: 0 10px;
          }
        }
      }
    }
  }


</style>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'Doubleimage',
    mixins: [images],
    props: {
      cardText: Array 
    }
  }
</script>